import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CourseBlock from './CourseBlock';
import { leftArrow, rightArrow } from '../../../constants/icons';
//import SampleImage2 from '../../../assets/images/sample2.jpg';
import CourseBundleDescription from './CourseBundleDescription';
import CourseAccordion from './CourseAccordion';
import CourseCurriculum from '../course-curriculum/CourseCurriculum';
import Tab from 'olive-react-myoneui/lib/Tab';
//import LinkWrapper from '../../LinkWrapper';

function CourseCarousel({ coursedetails }) {
  const ref = useRef(null);

  const handleNextSlide = () => {
    ref.current.slickNext();
  };

  const handlePrevSlide = () => {
    ref.current.slickPrev();
  };
  const [selectedItem, setSelectedItem] = useState(null);

  const handleClick = (item) => {
    let courseSingle = {};
    //const obj = JSON.parse('{"name":"John", "age":30, "city":"New York"}');
    courseSingle['course'] = item;
    window.location.href = `/${courseSingle['course']['cb_slug']}`;
  };
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: true,
  };

  return (
    <>
      {/* <div className="mk-bundle-courses mk-scroll-horizontal carousel-course-bundle mk-res-bundle-courses"> */}
        {coursedetails?.course_details.map((coursedetailz, i) => (
          <div key="{coursedetailz.id}" className={
            JSON.stringify(coursedetailz) ===
            JSON.stringify(selectedItem?.course)
              ? 'mk-bundle-course-wrapper active'
              : 'mk-bundle-course-wrapper'
          }>
            <CourseBlock
              className={
                JSON.stringify(coursedetailz) ===
                JSON.stringify(selectedItem?.course)
                  ? 'active'
                  : ''
              }
              courseDetails={coursedetailz}
              onClick={() => handleClick(coursedetailz)}
            />
          </div>
        ))}
    </>
  );
}

export default CourseCarousel;
